import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.course');
import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-course',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.course/view.scss */
:host {
  display: block;
  min-height: 100%;
  color: #263d35;
  background: #faf8f4;
  font-family: "SUIT", "Pretendard", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

* {
  box-sizing: border-box;
}

button, input, select, textarea {
  font: inherit;
}

button {
  border: 0;
  cursor: pointer;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

a {
  color: inherit;
}

.memory-trip-app {
  min-height: 100%;
  container-type: inline-size;
  background: #faf8f4;
  -webkit-font-smoothing: antialiased;
}

.product-header {
  position: sticky;
  top: 0;
  z-index: 25;
  display: flex;
  min-height: 80px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 16px clamp(20px, 4vw, 56px);
  border-bottom: 1px solid #e8eae4;
  background: rgba(250, 248, 244, 0.96);
  backdrop-filter: blur(16px);
}

.brand-button {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 0;
  color: #263d35;
  background: transparent;
  text-align: left;
}

.brand-mark {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  border-radius: 12px;
  background: #263d35;
  color: #fff;
}

.brand-mark svg {
  width: 26px;
  height: 26px;
}

.brand-button span:last-child {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.brand-button strong {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.brand-button small {
  color: #8a837b;
  font-size: 11px;
}

.product-nav, .header-actions {
  display: flex;
  align-items: center;
  gap: 22px;
}

.product-nav a {
  color: #625d57;
  font-size: 14px;
  font-weight: 650;
  text-decoration: none;
}

.product-nav button {
  padding: 11px 18px;
  border-radius: 999px;
  background: #527b66;
  color: #fff;
  font-size: 14px;
  font-weight: 750;
}

.header-actions {
  gap: 8px;
}

.save-state {
  margin-right: 8px;
  color: #8a837b;
  font-size: 12px;
}

.text-button {
  padding: 8px 10px;
  border-radius: 9px;
  background: transparent;
  color: #625d57;
  font-size: 13px;
  font-weight: 700;
}

.text-button:hover {
  background: rgba(120, 145, 124, 0.1);
}

.hero-section {
  display: grid;
  min-height: 600px;
  grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr);
  align-items: center;
  gap: clamp(28px, 4vw, 56px);
  max-width: 1440px;
  margin: 0 auto;
  padding: 48px clamp(24px, 4vw, 56px) 64px;
}

.hero-copy {
  position: relative;
  z-index: 2;
}

.eyebrow, .step-kicker {
  margin: 0 0 17px;
  color: #527b66;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.hero-copy h1 {
  margin: 0;
  color: #263d35;
  font-family: inherit;
  font-size: clamp(40px, 4.4cqw, 66px);
  font-weight: 750;
  letter-spacing: -0.065em;
  line-height: 1.2;
  word-break: keep-all;
}

.hero-copy h1 em {
  color: #527b66;
  font-style: normal;
}

.hero-description {
  max-width: 400px;
  margin: 24px 0 0;
  color: #6c746d;
  font-size: 16px;
  line-height: 1.85;
  word-break: keep-all;
}

.hero-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin-top: 30px;
}

.primary-button, .secondary-button {
  display: inline-flex;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 22px;
  border-radius: 12px;
  font-weight: 800;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.primary-button {
  background: #263d35;
  color: #fff;
  box-shadow: none;
}

.primary-button:hover {
  transform: translateY(-2px);
  background: #395a49;
  box-shadow: 0 6px 16px rgba(38, 61, 53, 0.12);
}

.primary-button svg {
  width: 20px;
  height: 20px;
}

.primary-button.large {
  min-height: 54px;
  padding: 15px 23px;
  border-radius: 10px;
  font-size: 15px;
}

.primary-button.full {
  width: 100%;
}

.secondary-button {
  border: 1px solid #d7d3cc;
  background: #fff;
  color: #4e4944;
}

.secondary-button:hover {
  transform: translateY(-1px);
  border-color: #9bac9e;
}

.secondary-button.sage-outline {
  border-color: #527b66;
  color: #657d69;
  background: #f6faf6;
}

.demo-note {
  max-width: none;
  color: #7b817a;
  font-size: 12px;
  line-height: 1.6;
}

.trust-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 34px;
  color: #766f68;
  font-size: 12px;
}

.trust-row span {
  display: flex;
  align-items: center;
  gap: 7px;
}

.trust-row svg {
  width: 17px;
  height: 17px;
  color: #527b66;
}

.hero-visual {
  position: relative;
  min-width: 0;
  height: 510px;
  min-height: 0;
}

.hero-visual > img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 55% center;
  border-radius: 18px;
  box-shadow: none;
}

.hero-photo-caption {
  position: absolute;
  top: 20px;
  right: 20px;
  bottom: auto;
  display: flex;
  flex-direction: column;
  max-width: 210px;
  gap: 3px;
  padding: 12px 15px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.94);
}

.hero-photo-caption span {
  color: #8b847d;
  font-size: 11px;
  font-weight: 700;
}

.hero-photo-caption strong {
  font-size: 14px;
}

.hero-photo-caption a {
  color: #657d69;
  font-size: 11px;
  text-decoration: underline;
}

.floating-memory {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 20px;
  width: auto;
  padding: 22px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  background: rgba(30, 52, 44, 0.84);
  color: #fff;
  backdrop-filter: blur(16px);
}

.floating-memory .small-label {
  color: #d8e5d8;
}

.floating-memory .memory-tags span {
  background: rgba(255, 255, 255, 0.12);
  color: #f0f3e9;
}

.small-label {
  color: #a97c66;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.floating-memory p {
  margin: 10px 0 16px;
  font-size: 17px;
  font-weight: 550;
  letter-spacing: -0.035em;
  line-height: 1.6;
  word-break: keep-all;
}

.memory-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.memory-tags span, .matched-row span {
  padding: 6px 10px;
  border-radius: 999px;
  background: #edf2ed;
  color: #657d69;
  font-size: 12px;
  font-weight: 750;
}

.feature-section {
  padding: 72px clamp(24px, 4vw, 56px);
  background: #eef2eb;
}

.section-heading {
  max-width: 720px;
  margin: 0 0 36px;
  text-align: left;
}

.section-heading h2, .process-copy h2 {
  margin: 0;
  color: #263d35;
  font-family: inherit;
  font-size: clamp(28px, 2.8vw, 40px);
  font-weight: 750;
  letter-spacing: -0.055em;
  line-height: 1.35;
  word-break: keep-all;
}

.section-heading > p:last-child, .process-copy > p {
  margin: 18px auto 0;
  color: #716a63;
  font-size: 16px;
  line-height: 1.75;
}

.feature-grid {
  display: grid;
  max-width: 1160px;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  margin: 0 auto;
}

.feature-card {
  position: relative;
  min-height: 240px;
  padding: 28px;
  overflow: hidden;
  border: 1px solid #e1e7dd;
  border-radius: 14px;
  background: #fafcf8;
  box-shadow: none;
}

.feature-index {
  position: absolute;
  top: 26px;
  right: 26px;
  color: #71846d;
  font-size: 12px;
  font-weight: 650;
  letter-spacing: 0.06em;
}

.feature-icon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 10px;
  background: #e7eee1;
  color: #527b66;
}

.feature-icon svg {
  width: 27px;
  height: 27px;
}

.feature-card h3 {
  margin: 24px 0 10px;
  font-size: 20px;
  letter-spacing: -0.035em;
}

.feature-card p {
  margin: 0;
  color: #746d66;
  font-size: 14px;
  line-height: 1.72;
}

.process-section {
  display: grid;
  max-width: 1280px;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 48px;
  margin: 0 auto;
  padding: 80px clamp(24px, 4vw, 56px);
}

.process-copy {
  align-self: center;
}

.process-copy .secondary-button {
  margin-top: 30px;
}

.process-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.process-list li {
  display: flex;
  min-height: 112px;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 14px;
  border: 0;
  border-bottom: 1px solid #e2e6dd;
  border-radius: 0;
  background: transparent;
}

.process-list li > span {
  display: grid;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  place-items: center;
  border-radius: 8px;
  background: #e8eedf;
  color: #48634a;
  font-size: 12px;
  font-weight: 700;
}

.process-list strong {
  font-size: 15px;
}

.process-list p {
  margin: 7px 0 0;
  color: #807870;
  font-size: 12px;
  line-height: 1.55;
}

.landing-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  padding: 38px clamp(24px, 6vw, 88px);
  background: #3f4a40;
  color: #fff;
}

.landing-footer strong {
  font-size: 18px;
}

.landing-footer p {
  margin: 6px 0 0;
  color: rgba(255, 255, 255, 0.68);
  font-size: 12px;
}

.wizard-shell {
  display: grid;
  min-height: calc(100vh - 72px);
  grid-template-columns: 240px minmax(0, 1fr);
}

.progress-panel {
  position: sticky;
  top: 80px;
  align-self: start;
  min-height: calc(100vh - 80px);
  padding: 34px 24px;
  border-right: 1px solid #e6eae2;
  background: #f3f5ef;
}

.progress-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.progress-title > span {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 13px;
  background: #527b66;
  color: #fff;
  font-weight: 850;
}

.progress-title div {
  display: flex;
  flex-direction: column;
}

.progress-title small {
  color: #9a928a;
  font-size: 11px;
  font-weight: 700;
}

.progress-title strong {
  margin-top: 2px;
  font-size: 14px;
}

.progress-list {
  position: relative;
  margin: 38px 0 0;
  padding: 0;
  list-style: none;
}

.progress-list:before {
  position: absolute;
  top: 18px;
  bottom: 18px;
  left: 17px;
  width: 1px;
  background: #dad7d0;
  content: "";
}

.progress-list li {
  position: relative;
  margin: 0 0 16px;
}

.progress-list button {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  padding: 7px 5px;
  background: transparent;
  color: #9a948d;
  text-align: left;
}

.step-dot {
  position: relative;
  z-index: 1;
  display: grid;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  place-items: center;
  border: 1px solid #d8d4ce;
  border-radius: 50%;
  background: #f6f3ee;
}

.step-dot em {
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
}

.step-dot svg {
  width: 18px;
  height: 18px;
}

.progress-list button > span:last-child {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.progress-list button small {
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.08em;
}

.progress-list button strong {
  font-size: 13px;
}

.progress-list li.active button {
  color: #526a56;
}

.progress-list li.active .step-dot {
  border-color: #527b66;
  background: #527b66;
  color: #fff;
  box-shadow: 0 0 0 5px rgba(120, 145, 124, 0.12);
}

.progress-list li.done button {
  color: #527b66;
}

.progress-list li.done .step-dot {
  border-color: #9caf9f;
  background: #edf2ed;
}

.progress-help {
  display: flex;
  gap: 10px;
  margin-top: 32px;
  padding: 15px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.65);
  color: #7c756e;
}

.progress-help svg {
  width: 19px;
  height: 19px;
  flex: 0 0 19px;
  color: #527b66;
}

.progress-help p {
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
}

.wizard-content {
  container-type: inline-size;
  min-width: 0;
  padding: clamp(36px, 5vw, 70px) clamp(24px, 6vw, 88px) 90px;
  background: #faf8f4;
}

.step-section {
  max-width: 920px;
  margin: 0 auto;
}

.step-section.wide-step {
  max-width: 1180px;
}

.step-heading {
  margin-bottom: 32px;
}

.step-heading h1 {
  margin: 0;
  color: #263d35;
  font-family: inherit;
  font-size: clamp(30px, 3.3vw, 44px);
  font-weight: 750;
  letter-spacing: -0.055em;
  line-height: 1.3;
  word-break: keep-all;
}

.step-heading > p:last-child, .split-heading > div > p:last-child {
  max-width: 700px;
  margin: 18px 0 0;
  color: #79716a;
  font-size: 15px;
  line-height: 1.7;
}

.split-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 30px;
}

.form-card, .story-card, .keyword-card, .moment-card, .timeline-card, .check-panel, .invite-editor {
  border: 1px solid #e2e7dd;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 4px 20px rgba(38, 61, 53, 0.025);
}

.form-card {
  padding: clamp(24px, 4vw, 42px);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
}

.field > span, .choice-group legend {
  color: #5b554f;
  font-size: 13px;
  font-weight: 780;
}

.field input, .field select, .field textarea, .analysis-card input {
  width: 100%;
  min-height: 48px;
  padding: 12px 14px;
  border: 1px solid #dcd7d0;
  border-radius: 10px;
  outline: 0;
  background: #fefdfb;
  color: #263d35;
  transition: border 0.18s, box-shadow 0.18s;
}

.field textarea {
  resize: vertical;
}

.field input:focus, .field select:focus, .field textarea:focus, .analysis-card input:focus, .story-card textarea:focus {
  border-color: #527b66;
  box-shadow: 0 0 0 4px rgba(120, 145, 124, 0.12);
}

.choice-group {
  padding: 0;
  margin: 0 0 25px;
  border: 0;
}

.choice-group legend {
  margin-bottom: 10px;
}

.choice-row {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
}

.option-chip, .keyword-chip {
  min-height: 44px;
  padding: 10px 16px;
  border: 1px solid #dce2d7;
  border-radius: 9px;
  background: #fff;
  color: #616b60;
  font-size: 13px;
  font-weight: 600;
}

.option-chip.selected, .keyword-chip.selected {
  border-color: #527b66;
  background: #edf2ed;
  color: #526a56;
  box-shadow: inset 0 0 0 1px #527b66;
}

.warning-chip.selected {
  border-color: #d49d7f;
  background: #fff0e8;
  color: #9a6043;
  box-shadow: inset 0 0 0 1px #d49d7f;
}

.privacy-note {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  margin-top: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #f5f7f3;
  color: #716b64;
}

.privacy-note svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  color: #527b66;
}

.privacy-note p {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
}

.privacy-note strong {
  color: #526a56;
}

.form-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
}

.form-card .form-actions {
  padding-top: 24px;
  border-top: 1px solid #efebe5;
}

.memory-form {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(320px, 0.8fr);
  gap: 20px;
}

.story-card, .keyword-card {
  padding: clamp(24px, 3vw, 34px);
}

.story-card label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 14px;
}

.story-card label strong, .keyword-card h2 {
  margin: 0;
  font-size: 18px;
}

.story-card label span {
  color: #a09991;
  font-size: 12px;
}

.story-card textarea {
  width: 100%;
  min-height: 280px;
  padding: 18px;
  border: 1px solid #ded9d2;
  border-radius: 13px;
  outline: 0;
  background: #fefdfb;
  color: #263d35;
  font-size: 15px;
  line-height: 1.8;
  resize: vertical;
}

.input-help, .keyword-card > p {
  color: #918981;
  font-size: 12px;
  line-height: 1.55;
}

.keyword-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 20px 0 24px;
}

.keyword-chip {
  min-height: 38px;
  padding: 8px 13px;
}

.photo-upload {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 16px;
  border: 1px dashed #cfc8bf;
  border-radius: 13px;
  background: #faf9f7;
  cursor: pointer;
}

.photo-upload input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.photo-icon {
  display: grid;
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  place-items: center;
  border-radius: 12px;
  background: #edf2ed;
  color: #657d69;
}

.photo-icon svg {
  width: 22px;
  height: 22px;
}

.photo-upload > span:last-child {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.photo-upload strong {
  font-size: 13px;
}

.photo-upload small {
  color: #968e86;
  font-size: 11px;
}

.photo-preview {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  padding: 10px;
  border-radius: 12px;
  background: #f5f7f3;
}

.photo-preview img {
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  border-radius: 9px;
  object-fit: cover;
}

.photo-preview > div {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 3px;
}

.photo-preview strong {
  overflow: hidden;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.photo-preview span {
  color: #888078;
  font-size: 11px;
}

.photo-preview button {
  align-self: flex-start;
  padding: 2px 0;
  background: transparent;
  color: #a5664e;
  font-size: 11px;
  text-decoration: underline;
}

.attachment-state {
  margin-top: 10px;
  color: #657d69;
  font-size: 12px;
}

.mode-badge, .demo-data-label {
  flex: 0 0 auto;
  padding: 8px 12px;
  border: 1px solid #e6c9b9;
  border-radius: 999px;
  background: #fff3ed;
  color: #a76f54;
  font-size: 11px;
  font-weight: 800;
}

.mode-badge.live {
  border-color: #b8c7b9;
  background: #edf2ed;
  color: #526a56;
}

.analysis-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.analysis-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
  padding: 18px;
  border: 1px solid #e4ded7;
  border-radius: 14px;
  background: #fff;
}

.analysis-label {
  color: #527b66;
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0.04em;
}

.analysis-card input {
  min-height: 42px;
  padding: 8px 10px;
}

.analysis-card small {
  color: #a09890;
  font-size: 11px;
}

.interpretation-note, .provenance-banner {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 16px 0;
  padding: 13px 15px;
  border-radius: 12px;
  background: #f4f6f2;
  color: #6e6862;
}

.interpretation-note svg, .provenance-banner svg {
  width: 19px;
  height: 19px;
  flex: 0 0 19px;
  color: #527b66;
}

.interpretation-note p, .provenance-banner p {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
}

.moment-card {
  margin-top: 22px;
  padding: clamp(24px, 4vw, 38px);
  background: linear-gradient(135deg, #fff, #f7f8f4);
}

.moment-card h2 {
  margin: 0;
  font-family: inherit;
  font-size: 26px;
  letter-spacing: -0.035em;
}

.moment-card > p:not(.step-kicker) {
  margin: 9px 0 22px;
  color: #807870;
  font-size: 12px;
}

.moment-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.moment-option {
  display: flex;
  align-items: center;
  gap: 11px;
  min-height: 54px;
  padding: 12px 15px;
  border: 1px solid #e0dbd4;
  border-radius: 12px;
  background: #fff;
  color: #5d5751;
  text-align: left;
}

.check-circle {
  display: grid;
  width: 23px;
  height: 23px;
  flex: 0 0 23px;
  place-items: center;
  border: 1px solid #d5d0c9;
  border-radius: 50%;
}

.check-circle svg {
  width: 16px;
  height: 16px;
}

.moment-option.selected {
  border-color: #527b66;
  background: #edf2ed;
  color: #526a56;
}

.moment-option.selected .check-circle {
  border-color: #527b66;
  background: #527b66;
  color: #fff;
}

.profile-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
  max-width: 320px;
}

.profile-summary span {
  padding: 7px 10px;
  border-radius: 999px;
  background: #fff;
  color: #6b645d;
  font-size: 11px;
  box-shadow: 0 3px 10px rgba(70, 65, 59, 0.06);
}

.recommendation-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 17px;
}

.destination-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #e2e7dd;
  border-radius: 14px;
  background: #fff;
  box-shadow: none;
}

.destination-photo {
  position: relative;
  height: 220px;
  overflow: hidden;
  background: #e8e8e4;
}

.destination-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.destination-card:hover .destination-photo img {
  transform: scale(1.035);
}

.rank-badge, .score-badge {
  position: absolute;
  top: 13px;
  padding: 7px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 850;
}

.rank-badge {
  left: 13px;
  background: #fff;
  color: #526a56;
}

.score-badge {
  right: 13px;
  background: rgba(63, 58, 53, 0.82);
  color: #fff;
  backdrop-filter: blur(8px);
}

.destination-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 22px;
}

.destination-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.region {
  color: #8d857e;
  font-size: 11px;
}

.destination-title h2 {
  margin: 4px 0 0;
  font-family: inherit;
  font-size: 23px;
  letter-spacing: -0.04em;
}

.data-status {
  flex: 0 0 auto;
  padding: 5px 7px;
  border-radius: 7px;
  background: #fff3ed;
  color: #a76f54;
  font-size: 10px;
  font-weight: 800;
}

.destination-body .summary {
  min-height: 48px;
  margin: 14px 0;
  color: #756e67;
  font-size: 12px;
  line-height: 1.65;
}

.matched-row {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.matched-row span {
  padding: 5px 7px;
  font-size: 11px;
}

.reason-box {
  margin: 16px 0;
  padding: 13px;
  border-radius: 11px;
  background: #f4f6f2;
}

.reason-box strong {
  color: #526a56;
  font-size: 11px;
}

.reason-box p {
  margin: 6px 0 0;
  color: #635d57;
  font-size: 12px;
  line-height: 1.55;
}

.fact-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin: 0 0 14px;
  padding: 12px 0;
  border-top: 1px solid #efebe5;
  border-bottom: 1px solid #efebe5;
}

.fact-list div {
  padding: 0 7px;
  text-align: center;
}

.fact-list div + div {
  border-left: 1px solid #efebe5;
}

.fact-list dt {
  color: #9b938b;
  font-size: 10px;
}

.fact-list dd {
  margin: 4px 0 0;
  color: #5f5953;
  font-size: 11px;
  font-weight: 750;
}

.info-details {
  margin-bottom: 13px;
}

.info-details summary {
  color: #657d69;
  font-size: 11px;
  font-weight: 750;
  cursor: pointer;
}

.detail-group {
  margin-top: 10px;
  padding: 10px;
  border-radius: 9px;
  background: #f6f8f4;
}

.detail-group.warning {
  background: #fff6f1;
}

.detail-group strong {
  font-size: 11px;
}

.detail-group ul {
  margin: 6px 0 0;
  padding-left: 15px;
  color: #746d66;
  font-size: 11px;
  line-height: 1.5;
}

.source-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
  padding-top: 10px;
}

.source-row span {
  color: #a09890;
  font-size: 10px;
  line-height: 1.4;
}

.source-row a {
  flex: 0 0 auto;
  color: #657d69;
  font-size: 11px;
  font-weight: 750;
}

.destination-body .primary-button {
  margin-top: 17px;
  min-height: 44px;
  font-size: 12px;
}

.empty-state {
  padding: 70px 20px;
  border: 1px dashed #d9d4cd;
  border-radius: 18px;
  text-align: center;
}

.empty-state h2 {
  margin: 0;
}

.empty-state p {
  color: #807870;
}

.rehearsal-layout {
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(420px, 1.08fr);
  gap: 18px;
}

.timeline-card, .check-panel {
  padding: 26px;
}

.card-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
}

.card-heading span {
  color: #527b66;
  font-size: 11px;
  font-weight: 850;
}

.card-heading h2 {
  margin: 5px 0 0;
  font-family: inherit;
  font-size: 22px;
}

.adjusted-badge {
  padding: 6px 9px;
  border-radius: 999px;
  background: #edf2ed;
}

.timeline-list {
  position: relative;
  margin: 27px 0 0;
  padding: 0;
  list-style: none;
}

.timeline-list:before {
  position: absolute;
  top: 12px;
  bottom: 15px;
  left: 108px;
  width: 1px;
  background: #ddd8d1;
  content: "";
}

.timeline-list li {
  position: relative;
  display: grid;
  grid-template-columns: 94px 18px 1fr;
  gap: 12px;
  min-height: 76px;
}

.timeline-time {
  padding-top: 3px;
  color: #918981;
  font-size: 11px;
  text-align: right;
}

.timeline-dot {
  position: relative;
  z-index: 1;
  display: block;
  width: 11px;
  height: 11px;
  margin-top: 3px;
  border: 3px solid #f6f3ee;
  border-radius: 50%;
  background: #527b66;
  box-shadow: 0 0 0 1px #527b66;
}

.timeline-dot.meal {
  background: #d39370;
  box-shadow: 0 0 0 1px #d39370;
}

.timeline-dot.rest {
  background: #b5a98d;
  box-shadow: 0 0 0 1px #b5a98d;
}

.timeline-list strong {
  font-size: 13px;
}

.timeline-list p {
  margin: 5px 0 0;
  color: #837b74;
  font-size: 11px;
  line-height: 1.55;
}

.metric-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 9px;
}

.metric-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
  padding: 14px 11px;
  border-radius: 11px;
  background: #f5f7f3;
  text-align: center;
}

.metric-card span {
  color: #7c756e;
  font-size: 11px;
}

.metric-card strong {
  color: #526a56;
  font-size: 22px;
}

.metric-card small {
  color: #a09991;
  font-size: 10px;
}

.check-list {
  display: grid;
  gap: 8px;
  margin-top: 18px;
}

.check-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 11px 12px;
  border: 1px solid #e5e0d9;
  border-radius: 11px;
}

.status-icon {
  display: grid;
  width: 26px;
  height: 26px;
  flex: 0 0 26px;
  place-items: center;
  border-radius: 50%;
}

.status-icon svg {
  width: 16px;
  height: 16px;
}

.check-item > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
}

.check-item > div > span {
  font-size: 10px;
  font-weight: 850;
}

.check-item strong {
  font-size: 12px;
}

.check-item p {
  margin: 2px 0 0;
  color: #857e76;
  font-size: 11px;
  line-height: 1.45;
}

.status-condition-met {
  border-color: #cfdbd0;
  background: #f7faf6;
}

.status-condition-met .status-icon {
  background: #dfeade;
  color: #526a56;
}

.status-condition-met > div > span {
  color: #657d69;
}

.status-adjust-needed {
  border-color: #edcab8;
  background: #fff8f4;
}

.status-adjust-needed .status-icon {
  background: #f5d7c8;
  color: #a66145;
}

.status-adjust-needed > div > span {
  color: #a66145;
}

.status-info-required {
  border-color: #e6dfc8;
  background: #fffdf6;
}

.status-info-required .status-icon {
  background: #eee6c9;
  color: #877744;
}

.status-info-required > div > span {
  color: #877744;
}

.compare-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-top: 18px;
  padding: 23px 28px;
  border-radius: 15px;
  background: #3f4a40;
  color: #fff;
}

.compare-heading {
  display: flex;
  max-width: 470px;
  flex-direction: column;
  gap: 5px;
}

.compare-heading span {
  color: #d0d9d1;
  font-size: 11px;
  font-weight: 800;
}

.compare-heading strong {
  font-size: 13px;
  line-height: 1.55;
}

.compare-values {
  display: flex;
  align-items: center;
  gap: 19px;
}

.compare-values > div {
  display: flex;
  flex-direction: column;
}

.compare-values small {
  color: rgba(255, 255, 255, 0.58);
  font-size: 10px;
}

.compare-values strong {
  font-size: 25px;
}

.compare-values span {
  color: rgba(255, 255, 255, 0.72);
  font-size: 11px;
}

.compare-values svg {
  width: 24px;
  height: 24px;
  color: #e8baa3;
}

.compare-values .after strong {
  color: #e8baa3;
}

.invite-tools {
  display: flex;
  gap: 8px;
}

.icon-button {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border: 1px solid #ded9d2;
  border-radius: 12px;
  background: #fff;
  color: #657d69;
}

.icon-button svg {
  width: 20px;
  height: 20px;
}

.invite-layout {
  display: grid;
  grid-template-columns: minmax(240px, 0.62fr) minmax(460px, 1.38fr);
  align-items: start;
  gap: 24px;
}

.invite-editor {
  display: grid;
  gap: 20px;
  padding: 24px;
}

.editor-tip {
  padding: 14px;
  border-radius: 11px;
  background: #fff7f2;
}

.editor-tip strong {
  color: #a76f54;
  font-size: 12px;
}

.editor-tip p {
  margin: 5px 0 0;
  color: #796f68;
  font-size: 11px;
  line-height: 1.55;
}

.invitation-card {
  overflow: hidden;
  border: 1px solid #e2e7dd;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 16px 40px rgba(38, 61, 53, 0.07);
}

.postcard-image {
  position: relative;
  height: 290px;
  overflow: hidden;
}

.postcard-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.postcard-image:after {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 48%, rgba(45, 47, 42, 0.64));
  content: "";
}

.postcard-image > span {
  position: absolute;
  z-index: 1;
  right: 24px;
  bottom: 20px;
  color: #fff;
  font-family: inherit;
  font-size: 13px;
}

.postcard-body {
  padding: clamp(26px, 5vw, 48px);
  background: linear-gradient(145deg, #fff, #fffaf6);
}

.postcard-brand {
  color: #527b66;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.1em;
}

.postcard-body h2 {
  max-width: 650px;
  margin: 14px 0 18px;
  font-family: inherit;
  font-size: clamp(30px, 3.5vw, 45px);
  letter-spacing: -0.055em;
  line-height: 1.23;
}

.letter-copy {
  max-width: 690px;
  margin: 0;
  color: #6e6760;
  font-size: 14px;
  line-height: 1.8;
  white-space: pre-line;
}

.trip-meta {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  margin: 28px 0;
  overflow: hidden;
  border: 1px solid #e9e3dc;
  border-radius: 12px;
  background: #e9e3dc;
}

.trip-meta div {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px;
  background: #fff;
}

.trip-meta span {
  color: #99918a;
  font-size: 10px;
}

.trip-meta strong {
  font-size: 12px;
}

.mini-itinerary {
  display: grid;
  gap: 10px;
}

.mini-itinerary article {
  display: grid;
  grid-template-columns: 100px 1fr;
  align-items: center;
  gap: 15px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #e5dfd8;
}

.mini-itinerary span {
  color: #527b66;
  font-size: 11px;
  font-weight: 800;
}

.mini-itinerary strong {
  font-size: 12px;
}

.why-box {
  margin-top: 23px;
  padding: 16px;
  border-radius: 12px;
  background: #edf2ed;
}

.why-box span {
  color: #657d69;
  font-size: 11px;
  font-weight: 850;
}

.why-box p {
  margin: 6px 0 0;
  color: #5d5751;
  font-size: 12px;
  line-height: 1.6;
}

.family-choice {
  margin-top: 20px;
  text-align: center;
}

.family-choice p {
  color: #6b645e;
  font-family: inherit;
  font-size: 16px;
}

.family-choice div {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.family-choice button {
  padding: 9px 12px;
  border: 1px solid #dcd6cf;
  border-radius: 999px;
  background: #fff;
  color: #6b645e;
  font-size: 11px;
  font-weight: 750;
}

.family-choice button.selected {
  border-color: #527b66;
  background: #527b66;
  color: #fff;
}

.invite-footnote {
  margin: 20px 0 0;
  color: #a09890;
  font-size: 10px;
  text-align: center;
}

.notice {
  display: flex;
  max-width: 1180px;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin: 0 auto 18px;
  padding: 12px 14px;
  border-radius: 11px;
  font-size: 12px;
}

.notice.success {
  background: #edf2ed;
  color: #526a56;
}

.notice.error {
  background: #fff0e8;
  color: #9b5b3e;
}

.notice button {
  padding: 3px;
  background: transparent;
  color: currentColor;
  font-size: 11px;
  text-decoration: underline;
}

.mobile-progress {
  display: none;
}

.loading-overlay {
  position: fixed;
  z-index: 100;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(53, 51, 47, 0.36);
  backdrop-filter: blur(7px);
}

.loading-card {
  width: min(360px, 100%);
  padding: 32px;
  border-radius: 18px;
  background: #fff;
  text-align: center;
  box-shadow: 0 24px 70px rgba(50, 47, 43, 0.25);
}

.loading-symbol {
  display: flex;
  height: 38px;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.loading-symbol i {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #527b66;
  animation: memoryPulse 1s infinite ease-in-out;
}

.loading-symbol i:nth-child(2) {
  animation-delay: 0.14s;
}

.loading-symbol i:nth-child(3) {
  animation-delay: 0.28s;
}

.loading-card strong {
  display: block;
  margin-top: 10px;
  font-size: 16px;
}

.loading-card p {
  margin: 8px 0 0;
  color: #8a837c;
  font-size: 12px;
}

@keyframes memoryPulse {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  30% {
    transform: translateY(-8px);
    opacity: 1;
  }
}
@media (max-width: 1180px) {
  .hero-section {
    gap: 28px;
  }
  .recommendation-grid {
    grid-template-columns: 1fr;
  }
  .destination-card {
    display: grid;
    grid-template-columns: 320px 1fr;
  }
  .destination-photo {
    height: 100%;
    min-height: 430px;
  }
  .rehearsal-layout {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 900px) {
  .product-header {
    min-height: 64px;
    padding: 10px 18px;
  }
  .brand-button small, .save-state {
    display: none;
  }
  .product-nav a {
    display: none;
  }
  .product-nav {
    gap: 0;
  }
  .hero-section {
    min-height: auto;
    grid-template-columns: 1fr;
    padding-top: 50px;
  }
  .hero-visual {
    height: 440px;
    min-height: 0;
  }
  .hero-visual > img {
    height: 100%;
  }
  .floating-memory {
    left: 18px;
    right: 18px;
    bottom: 18px;
  }
  .feature-grid {
    grid-template-columns: 1fr;
  }
  .feature-card {
    min-height: auto;
  }
  .process-section {
    grid-template-columns: 1fr;
    gap: 45px;
  }
  .wizard-shell {
    display: block;
    min-height: calc(100vh - 64px);
  }
  .progress-panel {
    display: none;
  }
  .wizard-content {
    padding: 28px 20px 70px;
  }
  .mobile-progress {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 12px;
    margin: 0 auto 28px;
    color: #657d69;
    font-size: 12px;
  }
  .mobile-track {
    height: 5px;
    overflow: hidden;
    border-radius: 999px;
    background: #e2ded8;
  }
  .mobile-track i {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: #527b66;
  }
  .memory-form {
    grid-template-columns: 1fr;
  }
  .recommendation-grid {
    grid-template-columns: 1fr;
  }
  .destination-card {
    display: flex;
  }
  .destination-photo {
    height: 260px;
    min-height: 0;
  }
  .invite-layout {
    grid-template-columns: 1fr;
  }
  .invite-editor {
    order: 2;
  }
}
@media (max-width: 640px) {
  .brand-mark {
    width: 36px;
    height: 36px;
  }
  .brand-mark svg {
    width: 22px;
    height: 22px;
  }
  .brand-button strong {
    font-size: 16px;
  }
  .header-actions .text-button:last-child {
    display: none;
  }
  .text-button {
    padding: 7px;
    font-size: 12px;
  }
  .hero-section {
    padding: 42px 20px 62px;
  }
  .hero-copy h1 {
    font-size: clamp(34px, 9cqw, 48px);
  }
  .hero-description br {
    display: none;
  }
  .hero-visual {
    height: 360px;
    min-height: 0;
  }
  .hero-visual > img {
    height: 100%;
    border-radius: 14px;
  }
  .hero-photo-caption {
    top: 14px;
    right: 14px;
    bottom: auto;
    padding: 10px 12px;
  }
  .floating-memory {
    width: auto;
    left: 14px;
    right: 14px;
    bottom: 14px;
    padding: 17px;
  }
  .floating-memory p {
    font-size: 14px;
  }
  .feature-section {
    padding: 72px 20px;
  }
  .section-heading {
    text-align: left;
  }
  .process-section {
    padding: 75px 20px;
  }
  .process-list {
    grid-template-columns: 1fr;
  }
  .landing-footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .wizard-content {
    padding: 24px 15px 70px;
  }
  .step-heading h1 {
    font-size: clamp(28px, 8cqw, 35px);
  }
  .split-heading {
    flex-direction: column;
    gap: 15px;
  }
  .profile-summary {
    justify-content: flex-start;
  }
  .form-card, .story-card, .keyword-card, .moment-card, .timeline-card, .check-panel, .invite-editor {
    border-radius: 14px;
  }
  .form-card {
    padding: 20px 17px;
  }
  .form-grid, .analysis-grid, .moment-options {
    grid-template-columns: 1fr;
  }
  .story-card textarea {
    min-height: 230px;
  }
  .form-actions {
    justify-content: stretch;
  }
  .form-actions button {
    flex: 1;
    padding-left: 10px;
    padding-right: 10px;
  }
  .destination-photo {
    height: 220px;
  }
  .destination-body {
    padding: 18px;
  }
  .fact-list {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .fact-list div + div {
    border-left: 0;
  }
  .rehearsal-layout {
    display: block;
  }
  .check-panel {
    margin-top: 14px;
  }
  .timeline-card, .check-panel {
    padding: 19px 15px;
  }
  .timeline-list:before {
    left: 79px;
  }
  .timeline-list li {
    grid-template-columns: 66px 18px 1fr;
    gap: 8px;
  }
  .metric-row {
    gap: 5px;
  }
  .metric-card {
    padding: 12px 5px;
  }
  .metric-card strong {
    font-size: 17px;
  }
  .compare-card {
    align-items: flex-start;
    flex-direction: column;
  }
  .compare-values {
    width: 100%;
    justify-content: space-between;
  }
  .invite-tools {
    width: 100%;
  }
  .trip-meta {
    grid-template-columns: 1fr;
  }
  .mini-itinerary article {
    grid-template-columns: 80px 1fr;
  }
  .family-choice div {
    flex-direction: column;
  }
  .postcard-body {
    padding: 25px 20px;
  }
  .postcard-image {
    height: 220px;
  }
}
button:focus-visible, a:focus-visible, .photo-upload:focus-within {
  outline: 3px solid #527b66;
  outline-offset: 4px;
}

h1, h2, h3, p {
  overflow-wrap: anywhere;
}

.trust-row {
  gap: 14px;
}

.destination-body h2 {
  letter-spacing: -0.04em;
}

@container (max-width: 1000px) {
  .wizard-shell {
    display: block;
  }
  .progress-panel {
    display: none;
  }
  .wizard-content {
    padding: 28px 24px 70px;
  }
  .mobile-progress {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 12px;
    margin: 0 auto 28px;
    color: #527b66;
    font-size: 12px;
  }
  .mobile-track {
    height: 5px;
    overflow: hidden;
    border-radius: 999px;
    background: #e2e7dd;
  }
  .mobile-track i {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: #527b66;
  }
}
@container (max-width: 760px) {
  .memory-form, .invite-layout, .rehearsal-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .invite-editor {
    order: 2;
  }
  .recommendation-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .destination-card {
    display: flex;
  }
  .destination-photo {
    height: 240px;
    min-height: 0;
  }
  .split-heading {
    flex-direction: column;
    gap: 16px;
  }
  .profile-summary {
    justify-content: flex-start;
  }
  .compare-card {
    align-items: flex-start;
    flex-direction: column;
    gap: 20px;
  }
}
@container (max-width: 480px) {
  .form-grid, .analysis-grid, .moment-options, .trip-meta {
    grid-template-columns: minmax(0, 1fr);
  }
  .timeline-list:before {
    left: 79px;
  }
  .timeline-list li {
    grid-template-columns: 66px 18px minmax(0, 1fr);
    gap: 8px;
  }
}
@container (max-width: 920px) {
  .hero-section {
    grid-template-columns: 1fr;
    min-height: auto;
  }
  .hero-copy h1 {
    font-size: clamp(36px, 6.8cqw, 56px);
  }
  .hero-visual {
    height: 420px;
  }
  .feature-grid {
    grid-template-columns: 1fr;
  }
  .feature-card {
    min-height: auto;
  }
  .process-section {
    grid-template-columns: 1fr;
    gap: 36px;
  }
}
@container (max-width: 480px) {
  .hero-copy h1 {
    font-size: clamp(34px, 9cqw, 44px);
  }
  .hero-visual {
    height: 360px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .primary-button, .secondary-button {
    transition: none;
  }
  .loading-symbol i {
    animation: none;
  }
}
@media print {
  :host {
    background: #fff;
  }
  .product-header, .progress-panel, .mobile-progress, .step-heading, .invite-editor, .form-actions, .notice, .no-print {
    display: none !important;
  }
  .wizard-shell, .wizard-content, .step-section, .invite-layout {
    display: block !important;
    padding: 0 !important;
    margin: 0 !important;
    max-width: none !important;
  }
  .invitation-card {
    position: fixed;
    z-index: 99999;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .postcard-image {
    height: 32vh;
  }
  .postcard-body {
    padding: 34px 48px;
  }
}`],
})
export class PageCourseComponent implements OnInit, OnDestroy {
    public isSeoulAI = false;
    public isBikeLink = false;
    private routeSub: any;
    private generation = 0;
    public currentStep = 0;
    public highestStep = 0;
    public busy = false;
    public busyLabel = '';
    public statusMessage = '';
    public errorMessage = '';
    public saveStateLabel = '자동 저장 켜짐';
    public analysisMode = 'demo';
    public photoPreview = '';
    public photoName = '';
    public recommendations: any[] = [];
    public selectedDestination: any = null;
    public plan: any = null;
    public selectedMoments: string[] = [];
    public inviteResponse = '';

    public steps = [
        { id: 1, short: '프로필', title: '부모님 프로필' },
        { id: 2, short: '추억', title: '추억 이야기' },
        { id: 3, short: '재해석', title: 'AI 추억 재해석' },
        { id: 4, short: '추천', title: '여행지 추천' },
        { id: 5, short: '리허설', title: '효도 리허설' },
        { id: 6, short: '초대장', title: '여행 초대장' }
    ];

    public profile: any = {
        title: '엄마',
        customTitle: '',
        ageGroup: '60대',
        startRegion: '수원',
        transport: '자가용',
        tripType: '당일치기',
        maxTravelHours: 2,
        maxWalkMeters: 1500,
        customWalkMeters: '',
        restIntervalMinutes: 60,
        preferredFood: '해산물',
        avoidFood: '',
        activities: ['자연 감상', '카페'],
        avoidConditions: ['가파른 경사', '긴 대기']
    };

    public memory: any = {
        story: '엄마가 젊었을 때 아빠랑 기차를 타고 바다를 보러 갔던 여행을 자주 이야기하셨어요. 바닷바람을 맞으면서 해산물을 먹었던 게 정말 좋았다고 하셨어요.',
        keywords: ['바다', '기차', '음식']
    };

    public analysis: any = null;

    public invite: any = {
        date: '',
        familyMessage: '엄마, 이번에는 조금 더 가까운 곳에서 천천히 그때의 풍경을 다시 만나봐요.'
    };

    public keywordOptions = ['바다', '산', '기차', '일출', '옛 거리', '전통시장', '꽃', '음식', '첫 여행', '신혼여행'];
    public activityOptions = ['자연 감상', '카페', '전통시장', '문화유산', '음식 탐방'];
    public avoidOptions = ['계단', '가파른 경사', '긴 대기', '장시간 이동'];
    public analysisFields = [
        { key: 'landscape', label: '주요 풍경' },
        { key: 'activities', label: '당시의 활동' },
        { key: 'food', label: '기억에 남는 음식' },
        { key: 'mood', label: '장소와 분위기' },
        { key: 'companions', label: '함께했던 사람' },
        { key: 'emotions', label: '감정·경험 해석' },
        { key: 'keep', label: '현재에도 지키고 싶은 요소' }
    ];

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) {}

    public async ngOnInit() {
        await this.service.init();
        this.routeSub = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) void this.openCurrentCourse();
        });
        await this.openCurrentCourse();
    }

    public async openCurrentCourse() {
        const generation = ++this.generation;
        const defaults = new Component(this.service, this.router);
        for (const key of Object.keys(defaults)) {
            if (!['service', 'router', 'generation', 'routeSub'].includes(key)) this[key] = defaults[key];
        }
        this.isSeoulAI = location.pathname === '/course/7901baff4be4473f8966109d5a790d54';
        this.isBikeLink = location.pathname === '/course/aafa5691f92f40e89818200a14c98a90';
        if (!this.isSeoulAI) {
            await this.service.render();
            return;
        }
        this.invite.date = this.defaultDate();
        this.restoreLocal();
        try {
            const response: any = await wiz.call('load_plan', { project_id: this.projectId() });
            if (generation !== this.generation) return;
            if (response.code === 200 && response.data && response.data.snapshot) {
                this.restore(response.data.snapshot);
                this.saveStateLabel = '서버 저장본 불러옴';
            }
        } catch (error) {
            if (generation !== this.generation) return;
            this.saveStateLabel = localStorage.getItem(this.storageKey()) ? '브라우저 저장본 불러옴' : '브라우저 자동 저장';
        }
        await this.service.render();
    }

    public ngOnDestroy() {
        this.generation++;
        this.routeSub?.unsubscribe();
    }

    private projectId() {
        const value = window.location.pathname.split('/').filter(Boolean).pop() || 'memory-trip';
        return value.replace(/[^A-Za-z0-9_-]/g, '').slice(0, 80) || 'memory-trip';
    }

    private storageKey() {
        return 'memory-trip-mvp:' + this.projectId();
    }

    private defaultDate() {
        const date = new Date();
        date.setDate(date.getDate() + 14);
        return date.toISOString().slice(0, 10);
    }

    private parentName() {
        return this.profile.title === '직접 입력'
            ? (this.profile.customTitle || '부모님')
            : this.profile.title;
    }

    private snapshot() {
        return {
            version: 1,
            currentStep: this.currentStep,
            highestStep: this.highestStep,
            profile: this.profile,
            memory: this.memory,
            analysis: this.analysis,
            analysisMode: this.analysisMode,
            selectedMoments: this.selectedMoments,
            recommendations: this.recommendations,
            selectedDestination: this.selectedDestination,
            plan: this.plan,
            invite: this.invite,
            inviteResponse: this.inviteResponse,
            photoName: this.photoName
        };
    }

    private restore(snapshot: any) {
        if (!snapshot || snapshot.version !== 1) return;
        this.currentStep = Number(snapshot.currentStep || 0);
        this.highestStep = Number(snapshot.highestStep || this.currentStep);
        this.profile = Object.assign({}, this.profile, snapshot.profile || {});
        this.memory = Object.assign({}, this.memory, snapshot.memory || {});
        this.analysis = snapshot.analysis || null;
        this.analysisMode = snapshot.analysisMode || 'demo';
        this.selectedMoments = snapshot.selectedMoments || [];
        this.recommendations = snapshot.recommendations || [];
        this.selectedDestination = snapshot.selectedDestination || null;
        this.plan = snapshot.plan || null;
        this.invite = Object.assign({}, this.invite, snapshot.invite || {});
        this.inviteResponse = snapshot.inviteResponse || '';
        this.photoName = snapshot.photoName || '';
    }

    private restoreLocal() {
        try {
            const raw = localStorage.getItem(this.storageKey());
            if (raw) this.restore(JSON.parse(raw));
        } catch (error) {
            localStorage.removeItem(this.storageKey());
        }
    }

    private saveLocal() {
        try {
            localStorage.setItem(this.storageKey(), JSON.stringify(this.snapshot()));
            this.saveStateLabel = '방금 자동 저장됨';
        } catch (error) {
            this.saveStateLabel = '저장 공간 확인 필요';
        }
    }

    public async renderAndSave() {
        this.saveLocal();
        await this.service.render();
    }

    private async call(action: string, data: any) {
        const response: any = await wiz.call(action, data);
        if (response.code !== 200) {
            throw new Error(response.data?.message || response.message || '요청을 처리하지 못했습니다.');
        }
        return response.data || {};
    }

    public async startJourney() {
        this.currentStep = 1;
        this.highestStep = Math.max(this.highestStep, 1);
        this.statusMessage = '';
        await this.renderAndSave();
    }

    public async showLanding() {
        this.currentStep = 0;
        await this.renderAndSave();
    }

    public async goToStep(step: number) {
        if (step > this.highestStep) return;
        this.currentStep = step;
        this.errorMessage = '';
        await this.renderAndSave();
    }

    public async nextFromProfile() {
        this.errorMessage = '';
        if (!this.parentName().trim() || !this.profile.startRegion.trim()) {
            this.errorMessage = '부모님 호칭과 출발 지역을 입력해주세요.';
            await this.service.render();
            return;
        }
        if (this.profile.maxWalkMeters === 'custom') {
            const custom = Number(this.profile.customWalkMeters);
            if (!custom || custom < 100 || custom > 10000) {
                this.errorMessage = '직접 입력 도보 거리는 100m~10,000m로 입력해주세요.';
                await this.service.render();
                return;
            }
            this.profile.maxWalkMeters = custom;
        }
        this.currentStep = 2;
        this.highestStep = Math.max(this.highestStep, 2);
        await this.renderAndSave();
    }

    public async toggleProfileList(field: string, value: string) {
        const list = this.profile[field] || [];
        this.profile[field] = list.includes(value)
            ? list.filter((item: string) => item !== value)
            : list.concat([value]);
        await this.renderAndSave();
    }

    public async toggleKeyword(value: string) {
        const list = this.memory.keywords || [];
        this.memory.keywords = list.includes(value)
            ? list.filter((item: string) => item !== value)
            : list.concat([value]);
        await this.renderAndSave();
    }

    public async selectPhoto(event: any) {
        const file: File = event.target.files && event.target.files[0];
        this.errorMessage = '';
        if (!file) return;
        if (!file.type.startsWith('image/') || file.size > 5 * 1024 * 1024) {
            this.errorMessage = '5MB 이하 이미지 파일만 첨부할 수 있어요.';
            await this.service.render();
            return;
        }
        this.photoName = file.name;
        const reader = new FileReader();
        reader.onload = async () => {
            this.photoPreview = String(reader.result || '');
            await this.renderAndSave();
        };
        reader.readAsDataURL(file);
    }

    public async removePhoto() {
        this.photoPreview = '';
        this.photoName = '';
        await this.renderAndSave();
    }

    public async analyzeMemory() {
        this.errorMessage = '';
        if ((this.memory.story || '').trim().length < 20) {
            this.errorMessage = '추억 이야기를 20자 이상 들려주세요.';
            await this.service.render();
            return;
        }
        this.busy = true;
        this.busyLabel = '추억의 장면을 정리하고 있어요';
        await this.service.render();
        try {
            const data = await this.call('analyze_memory', {
                story: this.memory.story,
                keywords: JSON.stringify(this.memory.keywords)
            });
            this.analysisMode = data.mode || 'demo';
            this.analysis = this.normalizeAnalysis(data.analysis);
            this.selectedMoments = (this.analysis.core_experiences || []).slice(0, 2);
            this.statusMessage = data.message || '추억 분석을 마쳤습니다.';
        } catch (error: any) {
            this.analysisMode = 'demo';
            this.analysis = this.normalizeAnalysis(this.fallbackAnalysis());
            this.selectedMoments = this.analysis.core_experiences.slice(0, 2);
            this.statusMessage = '서버 연결 없이 브라우저 데모 분석을 사용했습니다.';
        } finally {
            this.busy = false;
            this.currentStep = 3;
            this.highestStep = Math.max(this.highestStep, 3);
            await this.renderAndSave();
        }
    }

    private normalizeAnalysis(value: any) {
        const result = Object.assign({}, value || {});
        this.analysisFields.forEach((field: any) => {
            const list = Array.isArray(result[field.key]) ? result[field.key] : [];
            result[field.key] = list;
            result[field.key + 'Text'] = list.join(', ');
        });
        result.core_experiences = Array.isArray(result.core_experiences) ? result.core_experiences : [];
        return result;
    }

    private analysisForApi() {
        const value: any = {};
        this.analysisFields.forEach((field: any) => {
            value[field.key] = String(this.analysis[field.key + 'Text'] || '')
                .split(',')
                .map((item: string) => item.trim())
                .filter(Boolean);
        });
        value.core_experiences = this.analysis.core_experiences || [];
        return value;
    }

    private fallbackAnalysis() {
        const text = ((this.memory.story || '') + ' ' + this.memory.keywords.join(' '));
        const sea = /바다|해변|파도|항구/.test(text);
        const train = /기차|열차/.test(text);
        const food = /회|해산물|조개|음식/.test(text);
        return {
            landscape: [sea ? '바다' : '이야기 속 풍경'],
            activities: [train ? '기차로 이동' : '함께 풍경 감상'],
            food: [food ? '해산물' : '입력에서 특정 음식이 확인되지 않음'],
            mood: [/조용|한적/.test(text) ? '조용한 분위기' : '편안한 분위기'],
            companions: ['부모님과 가족'],
            emotions: ['행복했을 가능성이 있는 기억으로 해석했으며, 사용자 확인이 필요합니다.'],
            keep: sea ? ['바다 풍경', '함께한 시간'] : ['그때의 풍경', '함께한 시간'],
            core_experiences: sea
                ? ['바다 풍경', '함께한 시간', food ? '여행지에서 맛본 음식' : '천천히 걷는 시간']
                : ['그때의 풍경', '함께한 시간'],
            interpretation_note: '브라우저 규칙 기반 데모 분석입니다. 감정은 사실로 단정하지 않았습니다.'
        };
    }

    public async toggleMoment(value: string) {
        this.selectedMoments = this.selectedMoments.includes(value)
            ? this.selectedMoments.filter((item: string) => item !== value)
            : this.selectedMoments.concat([value]);
        await this.renderAndSave();
    }

    public async findRecommendations() {
        this.errorMessage = '';
        if (!this.selectedMoments.length) {
            this.errorMessage = '가장 중요하게 이어가고 싶은 순간을 하나 이상 선택해주세요.';
            await this.service.render();
            return;
        }
        this.busy = true;
        this.busyLabel = '조건에 맞는 실제 관광지를 찾고 있어요';
        await this.service.render();
        try {
            const data = await this.call('recommend_places', {
                profile: JSON.stringify(this.profileForApi()),
                analysis: JSON.stringify(this.analysisForApi()),
                selected_moments: JSON.stringify(this.selectedMoments)
            });
            this.recommendations = data.recommendations || [];
            if (!this.recommendations.length) throw new Error('추천 후보가 없습니다.');
            this.statusMessage = '공식 출처로 존재를 확인한 후보 3곳을 찾았습니다.';
        } catch (error: any) {
            this.recommendations = this.fallbackRecommendations();
            this.statusMessage = '서버 연결 없이 포함된 관광지 샘플 데이터를 사용했습니다.';
        } finally {
            this.busy = false;
            this.currentStep = 4;
            this.highestStep = Math.max(this.highestStep, 4);
            await this.renderAndSave();
        }
    }

    private profileForApi() {
        return {
            title: this.parentName(),
            age_group: this.profile.ageGroup,
            start_region: this.profile.startRegion,
            transport: this.profile.transport,
            max_travel_hours: Number(this.profile.maxTravelHours),
            max_walk_meters: Number(this.profile.maxWalkMeters),
            rest_interval_minutes: Number(this.profile.restIntervalMinutes),
            preferred_food: this.profile.preferredFood,
            avoid_food: this.profile.avoidFood,
            activities: this.profile.activities,
            avoid_conditions: this.profile.avoidConditions
        };
    }

    private fallbackRecommendations() {
        const base = [
            ['gungpyeong-port', '궁평항', '경기도 화성시 서신면', '서해 낙조와 해송 풍경, 수산시장을 함께 만날 수 있는 항구입니다.', 'https://tour.hscity.go.kr/NEW/common/images/contents/nature2_1.jpg', 'https://tour.hscity.go.kr/NEW/1tour/nature2.jsp'],
            ['jeongok-port', '전곡항', '경기도 화성시 서신면', '바다와 하얀 요트 풍경을 감상할 수 있는 마리나 항구입니다.', 'https://tour.hscity.go.kr/NEW/common/images/contents/nature4_1.jpg', 'https://tour.hscity.go.kr/NEW/1tour/nature4.jsp'],
            ['seohaerang-cablecar', '서해랑 제부도해상케이블카', '경기도 화성시 전곡항·제부도', '바다와 갯벌 풍경을 조망하는 해상 케이블카입니다.', 'https://tour.hscity.go.kr/NEW/common/images/contents/nature24_1.jpg', 'https://tour.hscity.go.kr/NEW/1tour/nature24.jsp']
        ];
        return base.map((item: any[], index: number) => ({
            id: item[0], name: item[1], region: item[2], summary: item[3], image: item[4],
            source_name: '화성시 문화관광', source_url: item[5], score: 88 - index * 5,
            matched: ['바다', '가족', '자연 감상'],
            reason: this.parentName() + '의 바다 풍경과 함께한 시간이라는 기억을 이어갈 수 있는 후보입니다.',
            constraint_status: 'info_required',
            constraint_notes: ['출발지 기준 차량 이동 시간 확인 필요', '현장 총 도보 거리 확인 필요'],
            accessibility: index === 1 ? ['장애인 전용 주차장', '엘리베이터', '경사로', '장애인 전용 화장실'] : ['공식 페이지 일부 정보 확인'],
            cautions: ['총 도보 거리', '계단 수', '당일 운영 정보'],
            demo_metrics: { walk_meters: 1850 - index * 200, continuous_minutes: 85 - index * 15, rest_count: 1 },
            data_label: '실제 관광지 · 공식 출처 확인 / 거리·시간 일부 확인 필요'
        }));
    }

    public async chooseDestination(destination: any) {
        this.busy = true;
        this.busyLabel = '여행 일정을 먼저 걸어보고 있어요';
        this.selectedDestination = destination;
        await this.service.render();
        try {
            const data = await this.call('rehearsal_plan', {
                profile: JSON.stringify(this.profileForApi()),
                destination: JSON.stringify(destination),
                adjusted: 'false'
            });
            this.plan = data.plan;
        } catch (error) {
            this.plan = this.fallbackPlan(destination, false);
        } finally {
            this.busy = false;
            this.currentStep = 5;
            this.highestStep = Math.max(this.highestStep, 5);
            await this.renderAndSave();
        }
    }

    private fallbackPlan(destination: any, adjusted: boolean) {
        const maxWalk = Number(this.profile.maxWalkMeters);
        const restInterval = Number(this.profile.restIntervalMinutes);
        const base = destination.demo_metrics || { walk_meters: 1850, continuous_minutes: 85, rest_count: 1 };
        const metrics = adjusted
            ? { walk_meters: Math.min(maxWalk, 1200), continuous_minutes: Math.min(restInterval, 45), rest_count: 2 }
            : Object.assign({}, base);
        const timeline: any[] = [
            { time: '09:00 예정', title: this.profile.startRegion + ' 출발', detail: '실제 이동 시간은 지도 경로로 출발 전에 확인합니다.', kind: 'move' },
            { time: '도착 후', title: destination.name + ' 풍경 감상', detail: '핵심 풍경을 중심으로 천천히 둘러보는 제안 일정입니다.', kind: 'memory' },
            { time: '점심 무렵', title: '선호 음식 식사', detail: (this.profile.preferredFood || '현지 식사') + ' 후보의 영업 여부를 확인합니다.', kind: 'meal' },
            { time: '오후', title: '앉아서 쉬는 시간', detail: '화장실과 좌석이 확인된 장소를 동선에 반영합니다.', kind: 'rest' },
            { time: '귀가 전', title: '같은 풍경에서 가족사진', detail: '추억의 핵심 장면을 오늘의 가족사진으로 남깁니다.', kind: 'memory' }
        ];
        if (adjusted) timeline.splice(2, 0, { time: '30~45분 활동 후', title: '추가 휴식', detail: '연속 활동을 줄이기 위한 데모 조정입니다.', kind: 'rest' });
        return {
            timeline,
            metrics,
            adjusted,
            provenance: '도보·연속 활동 수치는 기능 시연용 가상 추정치이며 실제 관광정보가 아닙니다.',
            checks: [
                { label: '하루 총 예상 도보', value: metrics.walk_meters + 'm (데모 추정치)', status: metrics.walk_meters <= maxWalk ? 'condition_met' : 'adjust_needed', detail: '희망 최대 ' + maxWalk + 'm와 비교했습니다.' },
                { label: '연속 활동 시간', value: metrics.continuous_minutes + '분 (데모 추정치)', status: metrics.continuous_minutes <= restInterval ? 'condition_met' : 'adjust_needed', detail: '희망 휴식 간격과 비교했습니다.' },
                { label: '차량 이동 시간', value: '확인 필요', status: 'info_required', detail: '실시간 지도 경로 데이터가 연결되지 않았습니다.' },
                { label: '접근성·계단', value: '일부 확인', status: 'info_required', detail: '공식 출처 외 상세 경사와 계단 수는 확인이 필요합니다.' },
                { label: '식사 운영 정보', value: '확인 필요', status: 'info_required', detail: '식당 확정 후 영업시간을 확인합니다.' },
                { label: '우천 대체 장소', value: '확인 필요', status: 'info_required', detail: '실내 대체 장소 데이터가 연결되지 않았습니다.' },
                { label: '관광지 운영 정보', value: '출발 전 재확인', status: 'info_required', detail: '공식 출처에서 당일 정보를 확인합니다.' }
            ]
        };
    }

    public async adjustPlan() {
        if (!this.selectedDestination || this.busy) return;
        this.busy = true;
        this.busyLabel = '핵심 추억은 남기고 부담을 줄이고 있어요';
        await this.service.render();
        try {
            const data = await this.call('rehearsal_plan', {
                profile: JSON.stringify(this.profileForApi()),
                destination: JSON.stringify(this.selectedDestination),
                adjusted: 'true'
            });
            this.plan = data.plan;
        } catch (error) {
            this.plan = this.fallbackPlan(this.selectedDestination, true);
        } finally {
            this.busy = false;
            this.statusMessage = '휴식을 늘리고 연속 활동과 도보 부담을 줄인 제안으로 바꿨습니다.';
            await this.renderAndSave();
        }
    }

    public async continueToInvite() {
        this.currentStep = 6;
        this.highestStep = 6;
        if (!this.invite.date) this.invite.date = this.defaultDate();
        await this.renderAndSave();
    }

    public statusText(status: string) {
        if (status === 'condition_met') return '조건 충족';
        if (status === 'adjust_needed') return '일정 조정 필요';
        return '정보 확인 필요';
    }

    public statusClass(status: string) {
        return 'status-' + status.replace('_', '-');
    }

    public inviteTitle() {
        const memoryWord = this.selectedMoments.includes('바다 풍경') ? '그때 좋아하던 바다' : '그때의 풍경';
        return this.parentName() + ', ' + memoryWord + '를 다시 보러 가요.';
    }

    public async setInviteResponse(value: string) {
        this.inviteResponse = value;
        this.statusMessage = value === 'yes'
            ? '부모님의 선택을 최종 일정에 반영했어요.'
            : '다른 여행 후보를 다시 살펴볼 수 있어요.';
        await this.renderAndSave();
    }

    public async savePlan(showMessage: boolean = true) {
        this.saveLocal();
        try {
            const data = await this.call('save_plan', {
                project_id: this.projectId(),
                snapshot: JSON.stringify(this.snapshot())
            });
            this.saveStateLabel = '서버 저장 완료';
            if (showMessage) this.statusMessage = '입력과 결과를 안전하게 저장했습니다.';
            return data;
        } catch (error) {
            this.saveStateLabel = '브라우저 저장 완료';
            if (showMessage) this.statusMessage = '서버 저장은 실패했지만 이 브라우저에는 저장했습니다.';
            return null;
        } finally {
            await this.service.render();
        }
    }

    public async shareInvite() {
        await this.savePlan(false);
        const text = this.inviteTitle() + '\n' + (this.selectedDestination?.name || '') + ' · ' + (this.invite.date || '날짜 협의');
        const url = window.location.href;
        try {
            if (navigator.share) {
                await navigator.share({ title: '기억나들이 여행 초대장', text, url });
                this.statusMessage = '공유 창을 열었습니다.';
            } else {
                await navigator.clipboard.writeText(text + '\n' + url);
                this.statusMessage = '초대 문구와 링크를 복사했습니다.';
            }
        } catch (error) {
            this.statusMessage = '공유가 취소되었어요.';
        }
        await this.service.render();
    }

    public printInvite() {
        window.print();
    }

    private drawWrappedText(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, maxWidth: number, lineHeight: number, maxLines: number = 20) {
        const words = text.split(' ');
        let line = '';
        let lineCount = 0;
        words.forEach((word: string) => {
            if (lineCount >= maxLines) return;
            const test = line ? line + ' ' + word : word;
            if (ctx.measureText(test).width > maxWidth && line) {
                ctx.fillText(line, x, y + lineCount * lineHeight);
                line = word;
                lineCount += 1;
            } else {
                line = test;
            }
        });
        if (line && lineCount < maxLines) ctx.fillText(line, x, y + lineCount * lineHeight);
        return y + (lineCount + 1) * lineHeight;
    }

    public exportInviteImage() {
        if (!this.selectedDestination || !this.plan) return;
        const canvas = document.createElement('canvas');
        canvas.width = 1080;
        canvas.height = 1350;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.fillStyle = '#FAF8F4';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#78917C';
        ctx.fillRect(0, 0, canvas.width, 32);
        ctx.fillStyle = '#3F3A35';
        ctx.font = '700 30px sans-serif';
        ctx.fillText('기억나들이', 80, 110);
        ctx.fillStyle = '#78917C';
        ctx.font = '700 58px sans-serif';
        let y = this.drawWrappedText(ctx, this.inviteTitle(), 80, 210, 920, 76, 3);
        ctx.fillStyle = '#3F3A35';
        ctx.font = '400 28px sans-serif';
        y = this.drawWrappedText(ctx, this.invite.familyMessage, 80, y + 30, 920, 46, 4);
        ctx.fillStyle = '#E8BAA3';
        ctx.fillRect(80, y + 34, 920, 170);
        ctx.fillStyle = '#3F3A35';
        ctx.font = '700 34px sans-serif';
        ctx.fillText(this.selectedDestination.name, 120, y + 94);
        ctx.font = '400 25px sans-serif';
        ctx.fillText((this.invite.date || '날짜 협의') + ' · ' + this.selectedDestination.region, 120, y + 145);
        let timelineY = y + 270;
        ctx.font = '700 28px sans-serif';
        ctx.fillText('우리의 하루', 80, timelineY);
        ctx.font = '400 24px sans-serif';
        this.plan.timeline.slice(0, 5).forEach((item: any, index: number) => {
            ctx.fillStyle = '#78917C';
            ctx.fillText(item.time, 80, timelineY + 58 + index * 88);
            ctx.fillStyle = '#3F3A35';
            ctx.fillText(item.title, 310, timelineY + 58 + index * 88);
        });
        ctx.fillStyle = '#7A746E';
        ctx.font = '400 20px sans-serif';
        ctx.fillText('기억을 따라, 오늘의 나들이를 만들다.', 80, 1280);
        const link = document.createElement('a');
        link.download = '기억나들이-여행초대장.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
        this.statusMessage = '여행 초대장을 이미지로 저장했습니다.';
        this.service.render();
    }

    public async resetJourney() {
        const confirmed = await this.service.modal.show({
            title: '새 여행을 시작할까요?',
            message: '현재 입력과 결과가 이 브라우저에서 초기화됩니다.',
            action: '새로 시작',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!confirmed) return;
        localStorage.removeItem(this.storageKey());
        window.location.reload();
    }
}

export default PageCourseComponent;